import { VaroAdvanceEligibilityResult } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import queryVaroAdvanceEligibility from 'services/graphql/queries/advance/varoAdvanceEligibility';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

export interface VaroAdvanceEligibility {
  varoAdvanceEligibility: VaroAdvanceEligibilityResult;
}

const useVaroAdvanceEligibility = () => {
  const router = useRouter();
  const [{ data, error, fetching }] = useQuery<VaroAdvanceEligibility>({
    query: queryVaroAdvanceEligibility,
    requestPolicy: 'cache-and-network',
  });
  const { defaultTitle, defaultMessage, cancelButtonTitle } =
    useDefaultErrorStrings();
  const cancel = () => {
    router.back();
  };
  const buttons = {
    primaryButton: {
      title: cancelButtonTitle,
      onPress: cancel,
    },
  };

  const errorModel = error?.message
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: defaultTitle,
        messageBody: defaultMessage,
        ...buttons,
      }
    : null;

  return {
    data,
    errorModel,
    fetching,
  };
};

export default useVaroAdvanceEligibility;
